import React from "react";
import CompanyWrapper from "../UserModule/user.style";
import PageTitle from "components/common/PageTitle";
import SubAdminCompanyReportTable from "../../components/subadmincompanyreportModule/SubAdminCompanyReportTable";
import { connect } from "react-redux";

const SubAdminCompanyReport = (props) => {
  return (
    <CompanyWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          title="sub admin company report"
          className="plr-15"
          iconClass="fas fa-chart-bar"
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/dashboard")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>
      <div className="user-tbl">
        <SubAdminCompanyReportTable {...props} />
      </div>
    </CompanyWrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.themeChanger,
  };
};

export default connect(mapStateToProps, null)(SubAdminCompanyReport);
